import { pxToRem } from '@withjoy/joykit/theme';

/**
 * A toolbar's pill trigger: light outline on white, fully rounded, 36px tall, as the hotel pick's design draws its
 * filter toggle, sort and currency picker side by side. Spread on a `ButtonV2`, or pass as its `Root` override props.
 * The button's own focus ring is kept.
 */
export const TOOLBAR_PILL_PROPS = {
  paddingX: 5,
  color: 'mono14',
  height: pxToRem(36),
  border: '1px solid',
  borderColor: 'mono3',
  backgroundColor: 'white',
  borderRadius: pxToRem(18),
  typographyVariant: 'label3',
  _hover: { backgroundColor: 'mono1', borderColor: 'mono5' },
} as const;
